import Vue from "vue";

import axios from "axios";

function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFTOKEN",
  headers: {
    "X-CSRFTOKEN": getCookie("csrftoken"),
  },
});

const COOKIE_EXPIRED_MSG = "Token is invalid or expired";

axiosIns.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    let error_message = null;
    if (error.response && error.response.data && error.response.data.messages) {
      error_message = error.response.data.messages[0].message;
    }
    
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      if (!error.config.retry && error_message === COOKIE_EXPIRED_MSG) {
        error.config.retry = true;
        try {
          const originalXsrfCookieName = axiosIns.defaults.xsrfCookieName;
          const originalXsrfHeaderName = axiosIns.defaults.xsrfHeaderName;
          
          // Call refresh endpoint
          await axiosIns.post("/refresh");
          
          // Restore original CSRF settings
          axiosIns.defaults.xsrfCookieName = originalXsrfCookieName;
          axiosIns.defaults.xsrfHeaderName = originalXsrfHeaderName;
          
          // Retry the original request
          return axiosIns(error.config);
        } catch (refreshError) {
          // If refresh fails, redirect to login
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          return Promise.reject(refreshError);
        }
      } else {
        // If it's not a token expiration or retry already attempted, redirect to login
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
        throw new Error("Authentication failed");
      }
    }
    
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
